// extracted by mini-css-extract-plugin
export var layout = "Layout-module--layout--D6fS3";